
import React from 'react';
import { Button } from '@/components/ui/button';

interface OrderFormSubmitProps {
  submitting: boolean;
  disabled?: boolean;
  buttonColor?: string; // Nouvelle prop pour la couleur du bouton
  buttonText?: string; // Nouvelle prop pour le texte du bouton
}

const OrderFormSubmit: React.FC<OrderFormSubmitProps> = ({ 
  submitting, 
  disabled, 
  buttonColor = 'bg-amber-600 hover:bg-amber-700', // Couleur par défaut
  buttonText = 'Commander الآن اطلب' // Texte par défaut
}) => {
  // Utiliser la couleur fournie ou se rabattre sur la couleur par défaut
  const buttonStyle = buttonColor || 'bg-amber-600 hover:bg-amber-700';
  
  return (
    <Button 
      type="submit" 
      className={`w-full ${buttonStyle} h-12 mt-4`}
      disabled={submitting || disabled}
    >
      {submitting ? 'Traitement en cours...' : buttonText}
    </Button>
  );
};

export default OrderFormSubmit;
